import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/attendance-management-system/overtime-monitoring/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "overtime-monitoring" entry is kept); the seo block below is a fallback.

export const overtimeMonitoring: ContentPage = {
  slug: "attendance-management-system/overtime-monitoring",
  template: "hrmsFeature",
  seo: {
    title: "Efficient Overtime Monitoring for Compliance",
    description: "Automate overtime tracking with real-time alerts and detailed reporting to ensure fair compensation and adherence to labor laws.",
    keywords: [
      "overtime monitoring",
      "automated overtime calculation",
      "overtime compliance",
      "real-time overtime alerts",
      "overtime management software.",
    ],
    ogImage: "/assets/data/seoimages/overtime-monitoring.webp",
  },
  leaf: {
    hero: {
      caption: "Overtime Monitoring",
      title: "Accurate Overtime Tracking and Management",
      description: "Ensure fair compensation and compliance with our sophisticated overtime monitoring system, reducing discrepancies and boosting morale.",
      h1: "caption",
    },
    split: {
      title: "Streamline Overtime Calculations",
      bullets: [
        { title: "Automated Calculation", description: "Configure rules for automatic overtime pay calculations." },
        { title: "Real-Time Alerts", description: "Get instant notifications for unauthorized or excessive overtime." },
        { title: "Detailed Reports", description: "Generate reports for management and payroll integration." },
        { title: "Custom Pay Rates", description: "Set varying overtime rates based on employee type or role." },
      ],
      image: "/assets/images/img/product/hrms/attendancems/overtime-monitoring.webp",
      imageAlt: "overtime-monitoring",
    },
    cardsHeading: {
      title: "Key Features of Attendance Management System",
      description: "Optimize Attendance management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Absence Management",
        href: "/hrms-software/attendance-management-system/absence-management",
        description: "Efficiently manage and track employee absences and leaves with our comprehensive absence management system, reducing disruptions and ensuring compliance.",
        image: "/assets/images/img/product/hrms/attendancems/absence-management_key_features.webp",
        imageAlt: "absence-management_key_features",
      },
      {
        title: "Real-Time Attendance Tracking",
        href: "/hrms-software/attendance-management-system/real-time-attendance-tracking",
        description: "Capture accurate employee attendance data in real-time, streamlining payroll processes and enhancing workforce management.",
        image: "/assets/images/img/product/hrms/attendancems/real_time-attendance_tracking_key_features.webp",
        imageAlt: "real_time-attendance_tracking_key_features",
      },
      {
        title: "Shift Management",
        href: "/hrms-software/attendance-management-system/shift-management",
        description: "Manage and automate employee shifts efficiently to ensure coverage and reduce scheduling conflicts with our advanced shift management tools.",
        image: "/assets/images/img/product/hrms/attendancems/shift_management_key_features.webp",
        imageAlt: "shift_management_key_features",
      },
      {
        title: "Geofencing Attendance",
        href: "/hrms-software/attendance-management-system/geofencing-attendance",
        description: "Utilize geofencing technology to manage employee attendance more securely and accurately, ideal for remote or on-site tracking.",
        image: "/assets/images/img/product/hrms/attendancems/geofencing_attendance_key_features.webp",
        imageAlt: "Image Description",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Manage Overtime Effectively with Our System!",
    relatedBlogsKeyword: "hrms-overtime-monitoring,hrms-geofencing-attendance,hrms-comprehensive-reporting",
    metaKey: "overtime-monitoring",
  },
  sections: [],
};
